// Entry: one CampaignApi for the whole app. C-F1/C-F2 run on the fixture (demo data in this browser). After the
// lock, VITE_API_URL picks HttpApi (the backend) and no screen changes.
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ErrorBoundary, ToastContainer } from '@the-kit/ui'
import '@the-kit/ui/styles.css'
import './index.css'
import { ApiProvider } from './api/ApiProvider'
import { createFixtureApi } from './api/fixture/FixtureApi'
import { createHttpApi } from './api/HttpApi'
import { App } from './app/App'

const apiUrl = import.meta.env.VITE_API_URL as string | undefined
const api = apiUrl ? createHttpApi(apiUrl) : createFixtureApi({ persist: true })
const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false, staleTime: 0 } },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <ApiProvider api={api}>
        <QueryClientProvider client={queryClient}>
          <App />
          <ToastContainer />
        </QueryClientProvider>
      </ApiProvider>
    </ErrorBoundary>
  </StrictMode>
)
